import { useServices } from './useServices';

export const useImageConverter = () => {
  return useServices().imageConverter;
};
